import React, { useEffect, useMemo, useState } from "react";
import brand from "../brand";
import { fetchResultHistory, formatDate, getTodayIsoDate, shareResult } from "../utils/resultApi";

const OldResult = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const [timeFilter, setTimeFilter] = useState("all");
  const [notice, setNotice] = useState("");
  const today = getTodayIsoDate();

  useEffect(() => {
    const loadHistory = async () => {
      try {
        setResults(await fetchResultHistory());
      } catch (err) {
        setError("Unable to load result history.");
      } finally {
        setLoading(false);
      }
    };

    loadHistory();
  }, []);

  const filteredResults = useMemo(() => {
    return results
      .filter((result) => (timeFilter === "all" ? true : result.time === timeFilter))
      .filter((result) => {
        const value = `${result.date} ${result.time}`.toLowerCase();
        return value.includes(query.toLowerCase().trim());
      })
      .sort((a, b) => `${b.date}-${b.time}`.localeCompare(`${a.date}-${a.time}`));
  }, [query, results, timeFilter]);

  const handleShare = async (result) => {
    try {
      const draw = brand.drawTimes.find((item) => item.key === result.time);
      const state = await shareResult({
        title: `${brand.name} ${draw?.label || result.time} Result`,
        text: `${brand.name} result for ${formatDate(result.date)}`,
        url: result.image_url,
      });
      setNotice(state === "copied" ? "Result link copied." : "Share panel opened.");
    } catch (err) {
      setNotice("Sharing is not available on this device.");
    }
  };

  return (
    <main className="page-shell history-page">
      <section className="page-hero compact-hero">
        <span className="eyebrow">Result archive</span>
        <h1>{brand.name} Old Results</h1>
        <p>
          Search previous draw dates, filter by draw time, and open the published
          result image directly from the archive.
        </p>
      </section>

      <section className="history-toolbar" aria-label="Search result history">
        <label>
          <span>Search date</span>
          <input
            type="search"
            placeholder="YYYY-MM-DD or 1pm"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
          />
        </label>
        <label>
          <span>Draw time</span>
          <select value={timeFilter} onChange={(event) => setTimeFilter(event.target.value)}>
            <option value="all">All draws</option>
            {brand.drawTimes.map((draw) => (
              <option key={draw.key} value={draw.key}>
                {draw.label}
              </option>
            ))}
          </select>
        </label>
      </section>

      {notice && <div className="toast-line">{notice}</div>}

      <section className="history-table-wrap">
        {loading ? (
          <div className="result-skeleton history-skeleton">
            <span />
            <span />
            <span />
          </div>
        ) : error ? (
          <div className="result-empty">{error}</div>
        ) : filteredResults.length === 0 ? (
          <div className="result-empty">No result records match your filter.</div>
        ) : (
          <table className="history-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Draw</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredResults.map((result) => {
                const draw = brand.drawTimes.find((item) => item.key === result.time);
                return (
                  <tr key={`${result.date}-${result.time}-${result.id || result.image_url}`}>
                    <td>
                      <strong>{formatDate(result.date)}</strong>
                      {result.date === today && <span className="today-pill">Today</span>}
                    </td>
                    <td>{draw?.label || result.time}</td>
                    <td>
                      <span className="status-pill">Published</span>
                    </td>
                    <td>
                      <div className="table-actions">
                        <a href={result.image_url} target="_blank" rel="noreferrer">
                          Open
                        </a>
                        <button type="button" onClick={() => handleShare(result)}>
                          Share
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </section>
    </main>
  );
};

export default OldResult;
